<form>
  <h1 mat-dialog-title></h1>
  <div mat-dialog-content  class="air-theme">
    <div class="main-container small-layout">
      <div class="toolbar-list">
        <div class="toolbar-list-title">
          <div fxLayout="row" fxLayoutAlign="start center">
            @if (client != null && client.id != null) {
              <h1>
              {{ 'common.edit' | translate }} {{ breadcrumbLabel }}</h1>
            }
            @if (client == null || client.id == null) {
              <h1>
              {{ 'clientEdit.general.newClient' | translate }}</h1>
            }
          </div>
          <div class="breadcrumbs">
            <a href="#">{{ 'common.start.label' | translate }}</a> /
            <a routerLink="/clients">{{ 'clientList.title' | translate }}</a> /
            @if (client != null && client.id != null) {
              <span>{{ breadcrumbLabel }}</span>
            }
            @if (client == null || client.id == null) {
              <span>{{ 'clientEdit.general.newClient' | translate }}</span>
            }
          </div>
        </div>
        <div class="toolbar-back-button">
          <a (click)="cancel()" mat-button>
            <mat-icon>undo</mat-icon> {{ 'button.back' | translate }}
          </a>
        </div>
      </div>

      <mat-card class="card">
        <mat-card-content>

          <div class="form-block">
            <div class="form-icon">
              <mat-icon>format_size</mat-icon>
            </div>
            <div class="form-content">

              <div fxFlex="50%" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'clientEdit.general.name.label' | translate }}</mat-label>
                  <input matInput name="name"
                    [(ngModel)]="client.name" [errorStateMatcher]="matcher" required>
                  <mat-error>
                    {{ 'clientEdit.general.name.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="10" fxFlex.lt-md="100%">
                <mat-checkbox id="nonPayments" name="nonPayments" [(ngModel)]="client.nonPayments">
                  {{ 'clientEdit.general.nonPayments.label' | translate }}
                </mat-checkbox>
              </div>
            </div>
            <div class="side-block"></div>
          </div>

          <div class="form-block">
            <div class="form-icon">
              <mat-icon>location_on</mat-icon>
            </div>
            <div class="form-content">

              <div fxFlex="50%" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'clientEdit.general.address.label' | translate }}</mat-label>
                  <input matInput name="address"
                    [(ngModel)]="client.address" [errorStateMatcher]="matcher" required>
                  <mat-error>
                    {{ 'clientEdit.general.address.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="50%" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'clientEdit.general.city.label' | translate }}</mat-label>
                  <input matInput name="city"
                    [(ngModel)]="client.city" [errorStateMatcher]="matcher">
                  <mat-error>
                    {{ 'clientEdit.general.city.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="50%" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'clientEdit.general.postalCode.label' | translate }}</mat-label>
                  <input matInput name="postalCode"
                    [(ngModel)]="client.postalCode" [errorStateMatcher]="matcher">
                  <mat-error>
                    {{ 'clientEdit.general.postalCode.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="50%" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'clientEdit.general.state.label' | translate }}</mat-label>
                  <input matInput name="state"
                    [(ngModel)]="client.state" [errorStateMatcher]="matcher">
                  <mat-error>
                    {{ 'clientEdit.general.state.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="50%" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'clientEdit.general.country.label' | translate }}</mat-label>
                  <input matInput name="country"
                    [(ngModel)]="client.country" [errorStateMatcher]="matcher">
                  <mat-error>
                    {{ 'clientEdit.general.country.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="50%" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'clientEdit.general.code.label' | translate }}</mat-label>
                  <input matInput name="code"
                    [(ngModel)]="client.code" [errorStateMatcher]="matcher">
                  <mat-error>
                    {{ 'clientEdit.general.code.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

            </div>
            <div class="side-block"></div>
          </div>

          @if (client != null && client.id != null) {
            <div class="form-block">
              <div class="form-icon">
                <mat-icon>camera_alt</mat-icon>
              </div>
              <div class="form-content">
                <div fxFlex="50" fxFlex.lt-md="100%" class="top-padding" fxLayout="column">
                  @if (image != null) {
                    <mat-slide-toggle [(ngModel)]="client.showLogo" name="showLogo" [checked]="true"
                      [disabled]="false">
                      {{ 'clientEdit.logo.showLogo' | translate }}
                    </mat-slide-toggle>
                  }
                  <div [ngClass]="image != null ? 'top-padding' : ''">
                    <button mat-raised-button (click)="uploadLogo.click()" class="stroked-primary">
                      <mat-icon>cloud_upload</mat-icon>
                      @if (image == null) {
                        <span> {{ 'button.uploadLogo' | translate }} </span>
                      }
                      @if (image != null) {
                        <span> {{ 'button.uploadNewLogo' | translate }} </span>
                      }
                    </button>
                  </div>
                  <input accept="image/*" hidden type="file" (change)="onLogoUpload($event)" #uploadLogo>
                </div>
                <div fxFlex="50" fxFlex.lt-md="100%" class="top-padding">
                  <img class="companyLogo" [src]="showImage()">
                </div>
              </div>
              <div class="side-block"></div>
            </div>
          }

          @if (showGroupToClone()) {
            <div class="form-block">
              <div class="form-icon">
                <mat-icon>folder_copy</mat-icon>
              </div>
              <div class="form-content">
                <div fxFlex="50" fxFlex.lt-md="100%" class="top-padding" fxLayout="column">
                  <mat-form-field class="campoFormulario" style="margin-top: -1em;">
                    <mat-label> {{ 'clientEdit.group' | translate }} </mat-label>
                    <mat-select #groupSelect name="idGroup" [(ngModel)]="client.idGroup" required>
                      <mat-option [value]="null"> -- </mat-option>
                      @for (group of groups; track group) {
                        <mat-option [value]="group.id">
                          {{ group.name }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="side-block"></div>
            </div>
          }

        </mat-card-content>
        @if (showContactPerson()) {
          <mat-toolbar color="secondary">
            {{ 'clientEdit.contact.person.title' | translate }}
            <button mat-icon-button (click)="openDialogPerson()">
              <mat-icon>add</mat-icon>
            </button>
          </mat-toolbar>
        }
        @if (showContactPerson()) {
          <mat-card-content>
            <div fxFlex="100%" fxFlex.lt-md="100%" class="top-padding">
              <ul>
                @for (person of client.persons; track person; let indexValue = $index) {
                  <li>
                    <div fxLayout="row">
                      <div fxFlex="20" fxLayout="column">
                        <div fxFlex="100">
                          {{ person.name }}
                        </div>
                        <div fxFlex="100">
                          {{ person.username }}
                        </div>
                      </div>
                      <div fxFlex="10">
                      </div>
                      <div fxFlex="10">
                        @if (person.preferential) {
                          <div> "Preferente"</div>
                        }
                      </div>
                      <div fxFlex>
                        <button mat-icon-button (click)="openDialogEditPerson(indexValue)" matTooltip="{{ 'button.edit' | translate }}">
                          <mat-icon>mode_edit</mat-icon>
                        </button>
                        <button mat-icon-button (click)="deleteRow(indexValue)" [disabled]="disableOfflineButton"
                          matTooltip="{{ 'button.delete' | translate }}">
                          <mat-icon>delete</mat-icon>
                        </button>
                        <button mat-icon-button (click)="restorePassword(indexValue)" matTooltip="{{ 'button.restore' | translate }}">
                          <mat-icon>settings_backup_restore</mat-icon>
                        </button>
                      </div>
                    </div>
                  </li>
                }
              </ul>
            </div>
          </mat-card-content>
        }
        <mat-card-actions>
          <div fxLayoutAlign="start center" class="form-footer-action">
            <button mat-raised-button color="primary" (click)="saveClient()">{{ 'button.save' | translate }}</button>
            @if (client.id != null) {
              <button mat-raised-button (click)="downloadAuditPdf()">
              {{ 'button.download-audit' | translate }}</button>
            }
            <button mat-button color="secondary" (click)="cancel()">
              <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
            </button>
          </div>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</form>